{
  "Please contact your organization's administrator to upgrade your plan.": "Veuillez contacter l'administrateur de votre organisation pour changer d'offre.",
  "business": "Business",
  "free": "Free",
  "pro": "Pro",
  "start": "Start",
  "01_Auf-Abgaenge": "Escaliers, ascenseurs",
  "01_Evakuation": "Évacuation",
  "01_Gebote_Verbote": "Règles, Interdictions",
  "01_gefahren": "Dangers Trafic",
  "01_Gleise": "Voies",
  "01_Richtungen": "Directions",
  "01_Verkehrsmittel": "Moyens de transport",
  "010_Basic": "Basique",
  "02_Brandbekaempfung": "Lutte contre l'incendie",
  "02_Entsorgung_Recycling": "Déchets, recyclage",
  "02_Parkieren": "Parking",
  "02_Sektoren": "Secteurs",
  "02_verbote": "Interdictions Trafic",
  "020_Arrow": "Flèches",
  "03_Barrierefreiheit": "Accessibilité",
  "03_gebote": "Obbligatoires Trafic",
  "03_Hygiene": "Hygiène",
  "03_vorschriftszeichen": "Signalisation Trafic",
  "04_Dienstleistungen": "Services",
  "04_Funktionsweise": "Fonctionnalités",
  "04_Klassen": "Classes",
  "04_rest": "Reste Trafic",
  "06_richtzeichen": "Signe indicatif",
  "080_Timetable": "Accessibilité",
  "10_zusatzzeichen": "Panneaux additionnels",
  "110_Location": "Localisation",
  "190_Installation": "Installations",
  "ab": "à partir de",
  "Abbrechen": "Annuler",
  "Abmelden": "Se déconnecter",
  "Absenden": "Envoyer",
  "Achtung": "Attention",
  "admin_settings": "Paramètres administrateur",
  "Adresse": "adresse",
  "aerial": "Satellite",
  "Aktuelle Zoomstufe": "Niveau de zoom actuel",
  "Aktueller Stand des Elements": "Niveau actuel de l'élément",
  "Alle Tags entfernen": "Supprimer tous les tags",
  "already in use for another drawing by this user.": "Nom déjà utilisé.",
  "Als PNG speichern": "Enregistrer au format PNG",
  "Als Standardplan festlegen": "Définir comme plan par défaut",
  "Am rechten Rand andocken": "Ancrer à droite",
  "andere": "autres",
  "Andocken lösen": "Désancrer",
  "Änderungen konnten nicht gespeichert werden": "Les modifications n'ont pas pu être enregistrées",
  "Änderungen werden gespeichert": "Enregistrer les modifications",
  "Anfang Icon": "Icône de début",
  "Anfrage versenden": "Envoyer la demande",
  "anfrage_form_success": "Nous vous remercions de votre demande. Nous vous contacterons dans les plus brefs délais.",
  "Anwenden": "Appliquer",
  "Auf Ausschnitt zentrieren": "Centrer sur l'étendue",
  "Auf Route zentrieren": "Zoom sur l'itinéraire",
  "Auf Zoomstufen beschränken": "Limiter au niveau de zoom",
  "aufgaenge": "Ascensions et descentes",
  "Auflösung": "Résolution",
  "Aus": "Désactivé",
  "Ausgewählte Elemente": "Éléments sélectionnés",
  "Ausrichtungshilfe": "Aide à l'alignement",
  "Ausschnitt festlegen": "Sélectionner une étendue",
  "Ausschnitt sperren": "Verrouiller l'étendue",
  "Ausser Zoomstufen Zoombeschränkung": "La limite de zoom sélectionnée se trouve en dehors de la zone actuellement visible.",
  "bahnlinien": "Lignes de chemin de fer",
  "bahnofplan": "Plans de gare",
  "Barrierefreie Route": "Itinéraire accessible",
  "Baselayers": "Fond de carte",
  "basemap": "Réseau trafic",
  "Bearbeiten": "Editer",
  "Benutzeranleitung": "Mode d'emploi",
  "Betreiber": "Gérant",
  "bike": "Vélo",
  "Bild einfügen": "Inserter un image",
  "Bild herunterladen": "Télécharger le plan",
  "bis": "à",
  "Bitte geben Sie einen Plannamen ein.": "Veuillez saisir un nom de plan.",
  "Bitte loggen Sie sich ein, um die Zeichnung zu exportieren.": "Veuillez vous connecter pour exporter le dessin.",
  "Bitte, Copyright zu kopieren": "La taille de l'exportation est trop petite pour afficher correctement le copyright. Veuillez vous assurer que le copyright suivant apparaît dans votre publication:",
  "Branche": "Secteur",
  "Bus": "Bus",
  "bus": "Bus",
  "buslinien": "Lignes de bus",
  "Car": "Voiture",
  "car": "Voiture",
  "Coach": "Autocar",
  "coach": "Autocar",
  "colorful": "Carte en couleurs",
  "Confirm remove plan": "Êtes-vous sûr de vouloir supprimer ce plan de votre profil?",
  "Construction": "Chantier",
  "Copyright kopiert!": "Copyright copié!",
  "custom_layout_dialog_description": "Vous pouvez intégrer votre plan dans un modèle PDF directement dans mapset et l'exporter. Nous concevons les modèles entièrement selon vos souhaits en ce qui concerne le format, le logo et l'identité visuelle ainsi que l'emplacement des textes et autres éléments. Envoyez-nous un message via ce formulaire et nous prendrons contact avec vous.",
  "custom_layout_dialog_title": "Créer un modèle personnalisé",
  "custom_layout_placeholder_message": "Je suis intéressé par une mise en page PDF personnalisée. Veuillez me contacter à {{user.email}}.",
  "custom_layout_placeholder_title": "Créer un modèle mapset pour {{user.email}}",
  "Datenschutz": "Protection des données",
  "Den bestehenden Plan können sie mit folgendem Link jederzeit weiter bearbeiten.": "Vous pouvez modifier le plan existant à tout moment avec le lien suivant.",
  "Der aktuelle Anmelde-Status hat sich geändert. Bitte laden Sie die Seite neu.": "Le statut de connexion actuel a changé. Veuillez recharger la page.",
  "Der geladene Plan ist ein Standardplan. Sie haben keine Rechte, um Standard-Pläne zu bearbeiten.": "Le plan chargé est un plan par défaut. Vouz n'avez pas le droit de modifier les plans par défaut.",
  "Der Plan wurde geändert": "Le plan a été modifié",
  "Dialog nicht mehr anzeigen": "Ne plus montrer ce messsage",
  "Did you know?": "Le saviez-vous?",
  "Die Zeichnung konnte nicht geladen werden.": "Le dessin n'a pas pu être chargé.",
  "Die Zeichnung konnte nicht geladen werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "Le dessin n'a pas pu être chargé. Veuillez vérifier votre connexion Internet et essayez à nouveau.",
  "Die zu exportierende Fläche ist zu groß. Die maximal zulässige Größe ist ": "The area to be exported is too large. The maximum size allowed is ",
  "Diese Pikto-Gruppe besteht aus": "Ce groupe consiste en",
  "Dieser Plan wurde nicht von Ihnen erstellt. Was möchten Sie tun?": "Ce plan n'a pas été créé par vous. Comment voulez-vous procéder?",
  "Dieser Plan wurde ursprünglich nicht von Ihnen benannt. Durch Ihre Änderungen wird der Planname für andere User auch aktualisiert.": "Ce plan n'a pas été nommé par vous à l'origine. Vos modifications mettront également à jour le nom du plan pour les autres utilisateurs.",
  "Drag to reorder": "Faire glisser pour réorganiser",
  "drawinfo.default_for": "Type de plan",
  "drawinfo.name": "Nom du plan",
  "drawinfo.provider": "Gérant",
  "drawinfo.station_identifier": "Id de la station",
  "drawinfo.station_name": "Nom de la station",
  "drawinfo.valid_from": "Valable à partir de",
  "drawinfo.valid_to": "Valable jusqu'au",
  "drawinfo.viewLinkValidity": "Validité du plan par standard",
  "Drehung": "Rotation",
  "Dreieck zeichnen": "Dessiner un triangle",
  "Ebene": "Couches",
  "Ebenen": "Couches",
  "editor_disabled_tooltip_picture": "disponible uniquement à partir du niveau de zoom 15",
  "editor_group_area": "Dessiner des surfaces",
  "editor_group_line": "Dessiner des lignes",
  "editor_group_point": "Dessiner des points",
  "Eine Position nach oben": "Amener en avant",
  "Eine Position nach unten": "Envoyer en arrière",
  "Einloggen": "Se connecter",
  "Einstellungen": "Paramêtres",
  "Element auswählen": "Sélectionner l'élément",
  "Element löschen": "Supprimer cet élément",
  "Element wurde in die Zwischenablage kopiert": "L'élément a été copié dans le presse-papiers.",
  "Elemente löschen": "Supprimer ces éléments",
  "Ende Icon": "Icône de fin",
  "Entfernen": "Retirer",
  "Error": "Erreur",
  "Etwas ist schief gelaufen.": "Quelque chose s'est mal passé.",
  "Events": "Événements",
  "Export im geteilten Plan ermöglichen": "Permettre l'exportation dans le plan partagé",
  "Export Optionen": "Options d'exportation",
  "export_kml_description": "Téléchargez votre plan au format KML pour l'utiliser dans d'autres outils.\n\n<italic>N'oubliez pas que la représentation du plan dans le KML peut être différente de celle de mapset.</italic>",
  "export_type_image": "Image",
  "export_type_kml": "KML",
  "export_type_pdf": "PDF",
  "export_width_too_small_message": "La surface à exporter est trop petite. Veuillez augmenter la largeur du cadre à {{width}} pixels afin d'afficher correctement tous les éléments du modèle.",
  "Exportieren": "Exporter",
  "Externe kommerzielle Einrichtungen": "Installations commerciales externes",
  "Fallend": "Décroissant",
  "Farbe ändern": "Modifier la couleur",
  "feature_styler_title_area": "Paramètres de surface",
  "feature_styler_title_icon": "Paramètres du pictogramme",
  "feature_styler_title_icon_group": "Paramètres du groupe de pictogrammes",
  "feature_styler_title_label": "Paramètres du texte",
  "feature_styler_title_line": "Paramètres de ligne",
  "feature_styler_title_picture": "Paramètres de l'image",
  "feature_styler_title_unknown": "Éditeur de style",
  "feature_type_area": "Surface",
  "feature_type_icon": "Pictogramme",
  "feature_type_icon_group": "Groupe de pictogrammes",
  "feature_type_label": "Texte",
  "feature_type_line": "Ligne",
  "feature_type_picture": "Image",
  "feature_type_unknown": "Élément",
  "feedback_form_error": "Désolé votre message n'a pu être envoyé. Nous essayons de corriger le problèmre au plus vite.",
  "feedback_form_file_helper_text": "Formats acceptés: {{formats}}",
  "feedback_form_success": "Nous vous remercions pour vos commentaires. Nous en tiendrons compte.",
  "feedback_form_text": "Vous avez trouvé une erreur dans mapset ou vous avez une suggestion d'amélioration ? Faites-le nous savoir en remplissant ce formulaire.\n\nLe mieux est de documenter les erreurs dans la base cartographique avec une capture d'écran ou un lien vers un plan mapset représentant la situation correcte.",
  "Ferry": "Ferry",
  "ferry": "Ferry",
  "File size too big": "Fichier(s) trop volumineux, max. {{size}}MB.",
  "Fläche zeichnen": "Dessiner un polygone",
  "Flächen-Transparenz": "Transparence de la surface",
  "Flächenfarbe": "Couleur de la surface",
  "foot": "Piéton",
  "form_attachment": "Pièces jointes",
  "form_message": "Message",
  "form_title": "Objet",
  "Format": "Format",
  "Fortschritt gespeichert": "Changements sauvegardés",
  "Fortschritt speichern": "Sauvegarder",
  "Fortschritt wird gespeichert": "Sauvegarde en cours",
  "Funicular": "Téléphérique",
  "funicular": "Téléphérique",
  "Für den Export von PDF-Layouts müssen Sie eingeloggt sein.": "Pour exporter des mises en page PDF, vous devez être connecté.",
  "Fussgänger": "Pied",
  "fusswege": "Voies piétonnes",
  "Ganzer Plan": "Tout le plan",
  "gebirgsnamen": "Noms de montagnes",
  "gewässerlabel": "Noms d'eau",
  "Gondola": "Télécabine",
  "gondola": "Télécabine",
  "gross": "grande",
  "Grösse": "Taille",
  "Gruppierung aufheben": "Separer le groupe",
  "guide.customlayout": "modèlepdf",
  "guide.downloadplan": "téléchargerleplan",
  "guide.drawarea": "dessinerunesurface",
  "guide.drawicon": "dessinerunicône",
  "guide.drawlabel": "dessineruntexte",
  "guide.drawline": "dessineruneligne",
  "guide.drawroute": "dessinerun'itinéraire",
  "guide.feedback": "feedback",
  "guide.insertpicture": "inserterunimage",
  "guide.layertoggler": "couches",
  "guide.newplan": "nouveauplan",
  "guide.plandefault": "plansstandard",
  "guide.plannamesandlist": "nomduplanetlistedesplans",
  "guide.plansaveconfirm": "sauvegarderconfirmer",
  "guide.plansaving": "sauvegarder",
  "guide.plansharing": "partagerleplan",
  "guide.settings": "paramêtres",
  "guide.tags": "plans-avec-tags",
  "Halt entfernen": "Supprimer arrêt",
  "Halt hinzufügen": "Ajouter arrêt",
  "haltekanten": "Bordures des arrêts",
  "Haltestelle": "station",
  "Haltestelle, Ort, Adresse, POIs ...": "Station, lieu, adresse, POIs ...",
  "Haltestelle suchen": "Rechercher une station",
  "haltestellen": "Arrêts",
  "haltestellenschilder": "Panneaux des arrêts",
  "Hide at next startup": "Ne plus afficher au prochain démarrage",
  "Hilfslinien": "Lignes directrices",
  "Hineinzoomen": "Agrandir",
  "Hintergrundfarbe": "Couleur de fond",
  "hoch": "haute",
  "Hochladen": "Sélectionner des fichiers",
  "hotkeys.featureDelete": "aussi en utilisant la touche Suppr ou Backspace",
  "hotkeys.featureFreehand": "dessin à main levée en utilisant Maj + bouton gauche de la souris",
  "hotkeys.featureGroup": "aussi en utilisant la touche Ctrl + G",
  "hotkeys.featureIconMultiselect": "sélection multiple par Ctrl + clic sur l'icône",
  "hotkeys.featureUngroup": "aussi en utilisant la touche Ctrl + Shift + G",
  "hotkeys.mapRotate": "faire pivoter la carte avec Alt + Maj + déplacer la carte",
  "icone_trenord": "Icônes Trenord",
  "Icons": "icônes",
  "Icons suchen": "Rechercher des icônes",
  "Ihre Änderungen konnten nicht gespeichert werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "Vos modifications n'ont pas pu être enregistrées. Veuillez vérifier votre connexion Internet et essayez à nouveau.",
  "Impressum": "Impressum",
  "Individuell": "Customisable",
  "industry.administration": "Administration publique",
  "industry.construction": "Construction et infrastructure",
  "industry.education": "Formation",
  "industry.emergency": "Services d'urgence",
  "industry.events": "Événements et salons",
  "industry.media": "Médias",
  "industry.ngo": "ONG et organisations",
  "industry.other": "Autre",
  "industry.planning": "Planification et ingénierie",
  "industry.tourism": "Tourisme",
  "industry.transport": "Transports publics",
  "Information zur Reisekette 1": "Information aux voyageurs 1",
  "Information zur Reisekette 2": "Information aux voyageurs 2",
  "Inspect-Modus": "Mode d'inspection",
  "Interne kommerzielle Einrichtungen": "Installations commerciales internes",
  "Jetzt loslegen": "Commencer",
  "Kartenausrichtung zurücksetzen": "Réinitialiser la rotation de la carte",
  "kein": "aucun",
  "Kein Plan vorhanden. Bitte erstellen Sie zuerst einen Plan.": "Aucun plan disponible. Veuillez d'abord créer un plan.",
  "kein QR-Code": "sans code QR",
  "Keine Icons gefunden.": "Aucune icône trouvée.",
  "Keine Pläne verfügbar.": "Aucun plan disponible.",
  "klein": "petite",
  "Kontur-Transparenz": "Transparence du contour",
  "Konturbreite": "Largeur de contour",
  "Konturfarbe": "Couleur de contour",
  "Konturtype": "Type de contour",
  "Kopie": "copie",
  "Kopieren": "Copie",
  "Kopiertes Element wurde eingefügt": "L'élément copié a été inséré.",
  "Kreis zeichnen": "Dessiner un cercle",
  "Kreuzweise": "Hachures",
  "Laden...": "Chargement...",
  "Lageplan": "Autres services",
  "landscape": "paysage",
  "linee_trenord": "Lignes Trenord",
  "Linie": "Ligne",
  "Linie zeichnen": "Dessiner une ligne",
  "Linien-Transparenz": "Transparence",
  "Linienabschluss": "Fin de ligne",
  "Linienanfang": "Début de ligne",
  "Linienbreite": "Largeur de ligne",
  "Linientyp": "Type de ligne",
  "Link kopiert!": "Lien copié!",
  "Link zum Bearbeiten": "Lien pour éditer",
  "Link zum Teilen": "Lien à partager",
  "mapset_layout_description": "Description",
  "mapset_layout_description_placeholder": "<b>Description</b> du plan ...",
  "mapset_layout_title": "Titre",
  "mapset_layout_title_placeholder": "Titre ...",
  "Maximale Anzahl an Haltestellen erreicht": "Nombre maximum d'arrêts atteint",
  "Meine Vorlage": "Mon modèle",
  "Mit diesem Link können Sie den Plan jederzeit weiter bearbeiten. Um die jetzige Version zu behalten, speichern Sie bitte diesen Link und erstellen dann einen": "Utiliser ce lien pour éditer votre plan ultérieurement. Pour conserver cette version, sauvegardez ce lien et commencer un",
  "Mit dieser Aktion wird der aktuelle Plan entfernt und ein neuer Plan gestartet. Wollen Sie wirklich einen neuen Plan erstellen?": "Cette action supprime le plan actuel et commence un nouveau plan. Voulez-vous vraiment créer un nouveau plan?",
  "mittel": "moyenne",
  "mostUsed": "Les plus utilisées",
  "Muster": "Motif de surface",
  "Nach ganz oben verschieben": "Amener au premier plan",
  "Nach ganz unten verschieben": "Envoyer à l'arrière-plan",
  "Nach Tags filtern...": "Filtrer par tags...",
  "neuen Plan": "nouveau plan",
  "Neuen Plan anlegen": "Créer un nouveau plan",
  "Neuen Tag erstellen": "Créer un nouveau tag",
  "Neuer Plan": "Nouveau plan",
  "neutrino": "Carte neutre",
  "NewPlan": "Cette action crée un nouveau plan. Voulez-vous vraiment continuer?",
  "Next Tip": "Suivant",
  "none": "Autres",
  "Nordpfeil": "Flèche indiquant le nord",
  "normal": "normale",
  "Nur durch Hilfslinien oder Ankerpunkten angeordnete Piktogramme behalten die Ausrichtung und Reihenfolge bei.": "Seuls les icônes disposés par des lignes auxiliaires ou des points d'ancrage conservent leur orientation et leur ordre.",
  "Öffnen": "Ouvrir",
  "Organisation": "Organisation",
  "Ort": "lieu",
  "Ort, Adresse, Haltestelle": "Lieu, adresse, station",
  "ortslabel": "Noms de lieux",
  "Ortung im geteilten Plan ermöglichen": "Permettre la localisation dans le plan partagé",
  "Pan to location": "Centrer la carte sur cet emplacement",
  "pärke": "Espaces verts",
  "Pflichtfeld": "Champs obligatoires",
  "Piktogramm zeichnen": "Dessiner un icône",
  "Piktogramm-Ankerpunkte": "Points d'ancrage des icônes",
  "Piktogramme": "pictogrammes",
  "Piktogramme gruppieren": "Grouper les icônes",
  "Piktogramme selektiert": "icônes",
  "Piktogrammen": "icônes",
  "Plan bearbeiten": "Modifier le plan",
  "Plan benennen": "Nommer un plan",
  "Plan duplizieren": "Dupliquer plan",
  "Plan entfernen": "Suppression d'un plan",
  "Plan exportieren": "Télécharger le plan",
  "Plan löschen": "Supprimer le plan",
  "Plan speichern": "Sauvegarder le plan",
  "Plan teilen": "Partager le plan",
  "Plan überschreiben": "Remplacer le plan",
  "Plan wechseln": "Changement de plan",
  "Planliste": "Liste des plans",
  "Planname": "Nom du plan",
  "pois": "POIs",
  "portrait": "portrait",
  "Previous Tip": "Précédent",
  "QR-Code": "Code QR",
  "QR-Code herunterladen": "Télécharger le code QR",
  "Quadrat zeichnen": "Dessiner un carré",
  "rail": "Train",
  "Rauszoomen": "Réduire",
  "Route kann für dieses Verkehrsmittel nicht berechnet werden!": "L'itinéraire ne peut pas être calculé pour ce moyen de transport!",
  "Route kreieren": "Créer itinéraire",
  "Route wird berechnet...": "Chargement d'itinéraire...",
  "Route zeichnen": "Dessiner un'itinéraire",
  "Routen-Finder": "Recherche d'itinéraire",
  "Routenlänge": "Longueur de l'itinéraire",
  "saturated": "Réseau trafic saturé",
  "SavePlanMessage": "Vous pouvez modifier le plan actuel à tout moment avec le nom <b>{{name}}</b> ou avec le lien suivant.",
  "schiffslinien": "Lignes de bateaux",
  "Schliessen": "Fermer",
  "Schreibgeschützt fortfahren": "Continuer en lecture seule",
  "Schriftkontur": "Contour d'écriture",
  "sehr hoch": "très haute",
  "seilbahnen": "Téléphériques",
  "Seite neu laden": "Recharger la page",
  "selektieren": "Sélectioner {{plan}}",
  "Serviceeinrichtungen": "Services",
  "Show tips at startup": "Afficher les conseils au démarrage",
  "Sicherheitseinrichtungen": "Sécurité",
  "Sie haben": "Vous avez sélectionnez",
  "Sie müssen eingeloggt sein, um diese Funktion nutzen zu können.": "Vous devez vous identifier pour utiliser ce service.",
  "Sie müssen eingeloggt sein, um diese Funktion weiterhin nutzen zu können.": "Vous devez vous identifier pour continuer à utiliser ce service.",
  "Sie müssen erst einen Plan erstellen.": "Vous devez d'abord établir un plan.",
  "Sie sind zur Zeit nicht angemeldet. Melden Sie sich an um mit der Bearbeitung fortzufahren, oder erstellen Sie einen neuen Plan.": "Vous êtes actuellement déconnecté. Veuillez vous connecter pour continuer à modifier ou créez un nouveau plan.",
  "Sie werden von allen geOps-Diensten abgemeldet.": "Vous allez être déconnecter de tout les services de geOps.",
  "Snapping aktivieren": "Activer le snapping",
  "Speichern": "Enregistrer",
  "Sprache": "Langue",
  "Standard": "Standard",
  "Standard plan ist bereit": "Vous pouvez consulter ce plan standard <a href='{{defaultsUrl}}' {{linkAttributes}}>online</a> pour une date donnée, ou le <a href='{{defaultPrintUrl}}' {{linkAttributes}}>télécharger au format PDF</a>.",
  "Standardplan öffnen": "Ouvrir le plan standard",
  "Standort": "Localisation",
  "Stapelreihenfolge": "Ordre d'empilement",
  "Start- und Endpunkte müssen unterschiedlich sein!": "Les points de départ et d'arrivée doivent être différents!",
  "Steigend": "Ascendant",
  "strassen": "Noms de las rues",
  "Subway": "Métro",
  "subway": "Métro",
  "Suche nach Plänen": "Recherche de plans",
  "Suche nach Tags...": "Recherche de tags...",
  "Sucheingabe löschen": "Effacer la recherche",
  "SwitchPlan": "Cette action ouvre le plan <b>{{name}}</b>. Voulez-vous vraiment continuer?",
  "Tag hinzufügen": "Créer un nouveau tag \"{{name}}\"",
  "tag_add_confirmation": "Les tags nouvellement créées seront accessibles aux autres membres de votre équipe. \n\n Êtes-vous sûr de vouloir ajouter le tag \"{{name}}\"?",
  "Tags": "Tags",
  "Text": "Texte",
  "Text hier eingeben": "Ecrivez un texte ici",
  "Text zeichnen": "Dessiner un texte",
  "Textausrichtung": "Alignement du texte",
  "Textfarbe": "Couleur du texte",
  "Tippen Sie, um neue Tags zu erstellen": "Tapez pour créer de nouveaux tags",
  "Tram": "Tram",
  "tram": "Tram",
  "tramlinien": "Lignes de tram",
  "tunnelbeschriftungen": "Noms des tunnels",
  "ubahnlinien": "Lignes de métro",
  "Um alle Funktionen in mapset zu nutzen, benötigt ihre Organisation ein Abonnement für mapset. Wenden Sie sich dazu bitte an support@mapset.ch.": "Pour utiliser toutes les fonctionnalités de mapset, votre organisation doit avoir un abonnement à mapset. Veuillez contacter <a href='mailto:support@mapset.ch' {{linkAttributes}}>support@mapset.ch</a>.",
  "Unbenannter Plan": "Plan non nommé",
  "unterfuehrungen": "Zones souterraines",
  "User abmelden": "Déconnecter {{user.email}}",
  "Validity overlaps with another constrained default plan": "La validité chevauche celle d'un autre plan par défaut pour cette station",
  "Verkehrsmittel": "Moyen de transport",
  "verkehrsmittel": "Moyens de transport",
  "Verwenden Sie diesen Link, um den Plan an andere Leute weiterzugeben oder in andere Anwendungen einzubinden.": "Utiliser ce lien pour partager ce plan avec une autre personne ou pour l’utiliser dans votre application.",
  "Vollflächig": "Rempli",
  "Vorschau": "Aperçu",
  "Weiter": "Continuer",
  "Wenn Ihre Zeichnung fertig ist, klicken Sie auf das rote SBB-Icon, um die Zeichnung im SBB-Webkartenportal anzuzeigen und zu teilen.": "Lorsque votre dessin est terminé, cliquez sur l'icône rouge des CFF pour visualiser et partager le dessin sur le portail des cartes web des CFF.",
  "Willkommen in mapset": "Bienvenue dans mapset",
  "Wollen Sie Ihren Plan überschreiben oder eine neue Version des Plans anlegen?": "Vous voulez remplacer le plan ou créer une nouvelle version du plan?",
  "Zeichnung in WKP anzeigen": "Afficher le dessin dans le portail de cartes",
  "Zeichnung speichern": "Sauvegarder le plan",
  "Zeichnung teilen": "Partager le plan",
  "Ziehen um die Reihenfolge zu ändern": "Glisser pour changer l'ordre",
  "Zoom-Höchstwert": "Zoom maximal",
  "Zoom-Tiefstwert": "Zoom minimal",
  "Zoomstufen": "Niveaux de zoom",
  "Zug": "Train",
  "Zurück": "Retour",
  "Zurück zum Plan": "Retour au plan",
  "Zurücksetzen": "Réinitialiser",
  "Dein Zugang zu dieser Organisation ist deaktiviert. Bitte wende dich an deinen Admin.": "Votre accès à cette organisation est désactivé. Veuillez contacter votre admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Bitte wende dich an deinen Admin.": "La période d'essai de votre organisation est terminée. Veuillez contacter votre admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Wähle einen Plan, um weiterzuarbeiten.": "La période d'essai de votre organisation est terminée. Choisissez un plan pour continuer.",
  "Die Einrichtung einer Organisation ist bald verfügbar.": "La configuration d'une organisation sera bientôt disponible.",
  "Organisation einrichten": "Configurer l'organisation",
  "Upgrade": "Mise à niveau",
  "You have reached your map limit. Upgrade your plan to create more maps.": "Vous avez atteint votre limite de cartes. Passez à une offre supérieure pour en créer davantage.",
  "Free-Plan": "Offre Free",
  "Deine kostenlose Phase ist abgelaufen": "Votre période gratuite est terminée",
  "Kein Zugang zum Editor": "Aucun accès à l'éditeur",
  "Die kostenlose Phase deiner Organisation ist abgelaufen. Bitte wende dich an deinen Admin.": "La période gratuite de votre organisation est terminée. Veuillez contacter votre admin.",
  "Deine Karten sind gespeichert und wieder verfügbar, sobald du einen Plan wählst.": "Vos cartes sont enregistrées et seront à nouveau disponibles dès que vous aurez choisi une offre.",
  "Plan wählen": "Choisir une offre",
  "Abo & Rechnungen": "Abonnement et factures",
  "Weiterhin erreichbar": "Toujours accessible",
  "Mein Konto": "Mon compte",
  "Geteilte Karten": "Cartes partagées",
  "Noch {{count}} Tage im Free-Plan_one": "Encore {{count}} jour avec l'offre Free",
  "Noch {{count}} Tage im Free-Plan_other": "Encore {{count}} jours avec l'offre Free",
  "Danach ist der Editor gesperrt. Deine Karten bleiben erhalten.": "Ensuite, l'éditeur sera verrouillé. Vos cartes seront conservées.",
  "Jetzt upgraden": "Changer d'offre",
  "Wähle einen Plan, um deine Organisation upzugraden.": "Choisissez une offre pour votre organisation."
}
